import React from 'react';
import { Link } from 'react-router-dom';
import '../App.css';

const Footer = () => {
    return (
        <footer className="App-footer">
            <div className="footer-content">
                <div className="footer-links">
                    <div className="footer-section">
                        <h4>Services</h4>
                        <Link to="/buyers">For Buyers</Link>
                        <Link to="/suppliers">For Suppliers</Link>
                        <Link to="/clients">Our Clients</Link>
                    </div>
                    <div className="footer-section">
                        <h4>Company</h4>
                        <Link to="/about">About Us</Link>
                        <Link to="/contact">Contact</Link>
                        <Link to="/investor-relations">Investor Relations</Link>
                    </div>
                    <div className="footer-section">
                        <h4>Legal</h4>
                        <Link to="/privacy">Privacy Policy</Link>
                    </div>
                </div>
                <p>&copy; 2024 Colorkarma Directory. All rights reserved.</p>
            </div>
        </footer>
    );
};

export default Footer;

